import { FC, useCallback, useState } from 'react';
import { format } from 'date-fns';
import { sortObjectArray, SortOrder } from 'utils/array';
import { Software } from 'models/software';
import SortableTable from 'components/UI/Table/SortableTable';
import { useNavigate } from 'react-router';
import { useAppDispatch } from 'hooks/redux';
import * as routes from 'router/Routes';
import { fetchSoftwareById } from 'store/softwareState/softwareState';

const headerCells = [
  {
    title: 'software.name',
    sortable: true,
  },
  {
    title: 'software.version',
    sortable: true,
  },
  {
    title: 'software.bundle_id',
    sortable: true,
  },
  {
    title: 'software.created_date',
    sortable: true,
  },
];

export type TableSoftware = {
  name: string;
  version: string;
  bundleId: string;
  createdAt: string;
  link: string;
};

type SoftwareTableProps = {
  softwares: Software[];
  initialActiveColumn: number;
  initialSortOrder: SortOrder;
};

const SoftwareTable: FC<SoftwareTableProps> = ({
  softwares,
  initialActiveColumn,
  initialSortOrder,
}) => {
  // State
  const [sortOrder] = useState<SortOrder>(initialSortOrder);
  const [activeColumnIndex] = useState<number>(initialActiveColumn);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const table: TableSoftware[] = softwares.map((software: Software) => {
    const { name, version, bundleId, createdAt } = software.attributes;
    const software1 = {
      name: name || '–',
      version: version || '–',
      bundleId: bundleId || '–',
      createdAt: createdAt
        ? format(Number(createdAt), 'yyyy-MM-dd HH:mm:ss')
        : '-',
      link: software.id || '–',
    };
    return software1;
  });

  // Sorted
  const sortedSoftwares: TableSoftware[] = sortObjectArray(
    table,
    Object.keys(table[0])[activeColumnIndex],
    sortOrder
  ) as TableSoftware[];

  // Fetch software and navigate
  const onClick = useCallback(
    (id: string) => {
      if (id) {
        dispatch(fetchSoftwareById(id));
      }
      navigate(`${routes.SOFTWARES}/${id}`);
    },
    [dispatch, navigate]
  );
  return (
    <SortableTable
      headerCells={headerCells}
      bodyRows={sortedSoftwares}
      onClick={onClick}
      sortOrder={SortOrder.Desc}
      sortIndex={2}
    />
  );
};

export default SoftwareTable;
